import NavigationListItem from 'components/NavigationListItem/NavigationListItem'
import { BlockTracking, NavigationProduct } from 'frontend/types'
import styles from './NavigationBlock.module.css'
import classNames from 'classnames'
import { blockItemClick } from 'frontend/utils/analytics/dataLayerDispatchers'

interface Props {
  products: NavigationProduct[]
  title: string | null
  blockTracking: BlockTracking
}
const NavigationBlock = ({ products, title, blockTracking }: Props) => {
  const oddNumber = products.length % 2 !== 0
  return (
    <div data-testid="NavigationBlock">
      <h2 className={styles.header}>{title}</h2>
      <ul className={styles.list}>
        {products.map((product, index) => (
          <NavigationListItem
            key={index}
            title={product.title}
            imageUrl={product.imageUrl}
            href={product.link}
            className={classNames(styles.item, {
              [`${styles.eight}`]: products.length === 8,
              [`${styles.seven}`]: products.length === 7,
              [`${styles.six}`]: products.length === 6,
              [`${styles.five}`]: products.length === 5,
              [`${styles.odd}`]: oddNumber,
            })}
            onClick={() => {
              blockItemClick({ blockTracking, itemIndex: index + 1, product })
            }}
          />
        ))}
      </ul>
    </div>
  )
}

export default NavigationBlock
